// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2CnQT","buttons":"RemoveExpirationActionButtons_buttons__2On1H"};